"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportData = exportData;
exports.getDetail = getDetail;
exports.getList = getList;
exports.updateStatus = updateStatus;
exports.updateSystemStatus = updateSystemStatus;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
var _nprogress = require("nprogress");
function getList(query) {
  return (0, _requestAuth.default)({
    url: '/xyGradeDiamond/page',
    method: 'get',
    params: query
  });
}
function getDetail(id) {
  return (0, _requestAuth.default)({
    url: '/xyGradeDiamond/detailList?id=' + id,
    method: 'get'
  });
}
function updateStatus(data) {
  return (0, _requestAuth.default)({
    url: '/xyGradeDiamond/update',
    method: 'post',
    data: data
  });
}

// 复审
function updateSystemStatus(status) {
  return (0, _requestAuth.default)({
    url: '/xyGradeDiamond/updateSystemStatus?status=' + status,
    method: 'get'
  });
}

// 导出
function exportData(params) {
  return (0, _requestAuth.default)({
    url: '/xyGradeDiamond/exportList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}